export default __webpack_public_path__ + "static/media/feature-a-3.27d6af2d.jpg";